import {types} from './types';

const initialState = {
    list: []
}

export function paymentReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}